import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { FileInstance } from '@app/features/device/model/device-imported-exported-data-interface';
import { FileUploaded, FileUrlResponse } from '@app/shared/models/file.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilehandlerService {
  constructor(private http: HttpClient, private appConfigService: AppConfigService) {}

  uploadFile(fd: FormData) {
    return this.http.post<FileUploaded>(`${this.appConfigService.getApi()}/filesystem/upload`, fd);
  }

  deleteFile(id: string): Observable<void> {
    return this.http.delete<void>(`${this.appConfigService.getApi()}/filesystem/${id}`);
  }

  deleteFiles(ids: string[]): Observable<void> {
    return this.http.post<void>(`${this.appConfigService.getApi()}/filesystem/delete`, ids);
  }

  getFileUrl(id: string, publicFile = false): Observable<FileUrlResponse> {
    return this.http.get<FileUrlResponse>(
      `${this.appConfigService.getApi()}${publicFile ? '/public' : ''}/filesystem/${id}/url`
    );
  }

  deleteUserImage(id: string): Observable<any> {
    return this.http.delete(`${this.appConfigService.getApi()}/users/${id}/image`);
  }

  downloadFile(id: string): Observable<Blob> {
    return this.http.get(`${this.appConfigService.getApi()}/filesystem/${id}/download`, { responseType: 'blob' });
  }

  getFileInfo(id: string): Observable<FileInstance> {
    return this.http.get<FileInstance>(`${this.appConfigService.getApi()}/filesystem/${id}/info`);
  }

  /**
   * Get file extension
   * @param filename the name of the file to get the extension
   */
  getFileExtension(filename: string): string {
    return filename.split('.').pop();
  }

  /**
   * Check if it is an allowed file type
   * @param filename The name of file to check
   */
  public checkIfImageAllowed(file: File) {
    return ['jpeg', 'jpg', 'png'].includes(this.getFileExtension(file.name));
  }
}
